const SocialNetworks = () => {
  return <div>SocialNetworks</div>
}

export default SocialNetworks